import { NAME_SPACE } from './constants';

export const SET_STREAM = `${NAME_SPACE}_SET_STREAM`;

export const SET_TRENDS = `${NAME_SPACE}_SET_TRENDS`;

export const RESET = `${NAME_SPACE}_RESET`;
